import React from 'react';
import '../template-file-css/document-file-template.css';


export const EDU_CANS = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EDU_CANS' className='file-pdf-document'>
            <div className='file-template'>
                <table >
                    <tr>
                        <td className='w-650'><span className='eleHeader'> CHILD RISK BEHAVIORS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence</td>
                        <td className='w-187'>1 = history; watch/prevent</td>
                        <td className='w-187'>2 = recent; action item </td>
                        <td className='w-187'>3 = acute; immediate action</td>
                    </tr>
                    <tr>
                        <td className='w-650'>Self-Harm</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfHarmNoEvidence" name="rbSelfHarm" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfHarmHistory" name="rbSelfHarm" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfHarmRecent" name="rbSelfHarm" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfHarmAcute" name="rbSelfHarm" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Aggressive Behavior</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAggressiveBehaviorNoEvidence" name="rbAggressiveBehavior" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAggressiveBehaviorHistory" name="rbAggressiveBehavior" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAggressiveBehaviorRecent" name="rbAggressiveBehavior" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAggressiveBehaviorAcute" name="rbAggressiveBehavior" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            Social Behavior
                            (N/A <input type="radio" id="rbSocialBehaviorNa" name="rbSocialBehavior" className='add-only' value="na" />)
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialBehaviorNoEvidence" name="rbSocialBehavior" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialBehaviorHistory" name="rbSocialBehavior" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialBehaviorRecent" name="rbSocialBehavior" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialBehaviorAcute" name="rbSocialBehavior" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CHILD RISK FACTORS </span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>

                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence</td>
                        <td className='w-187'>1 = history; watch/prevent</td>
                        <td className='w-187'>2 = recent; action item </td>
                        <td className='w-187'>3 = acute; immediate action</td>
                    </tr>
                </table>
                <table>
                    <tr>
                    </tr>
                    <tr>
                        <td className='w-650'>Birth Weight</td>
                        <td className='w-25'>
                            <input type="radio" id="rbBirthWeightNoEvidence" name="rbBirthWeight" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbBirthWeightHistory" name="rbBirthWeight" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbBirthWeightRecent" name="rbBirthWeight" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbBirthWeightAcute" name="rbBirthWeight" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Pica</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPicaNoEvidence" name="rbPica" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPicaHistory" name="rbPica" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPicaRecent" name="rbPica" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPicaAcute" name="rbPica" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Prenatal Care</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPrenatalCareEvidence" name="rbPrenatalCare" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPrenatalCareHistory" name="rbPrenatalCare" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPrenatalCareRecent" name="rbPrenatalCare" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPrenatalCareAcute" name="rbPrenatalCare" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Labor & Delivery</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLaborDeliveryEvidence" name="rbLaborDelivery" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLaborDeliveryHistory" name="rbLaborDelivery" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLaborDeliveryRecent" name="rbLaborDelivery" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLaborDeliveryAcute" name="rbLaborDelivery" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Substance Exposure</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceExposureEvidence" name="rbSubstanceExposure" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceExposureHistory" name="rbSubstanceExposure" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceExposureRecent" name="rbSubstanceExposure" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceExposureAcute" name="rbSubstanceExposure" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Parent/Sibling Problem</td>
                        <td className='w-25'>
                            <input type="radio" id="rbParentSiblingProblemEvidence" name="rbParentSiblingProblem" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParentSiblingProblemHistory" name="rbParentSiblingProblem" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParentSiblingProblemRecent" name="rbParentSiblingProblem" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbParentSiblingProblemAcute" name="rbParentSiblingProblem" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Maternal Availability</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaternalAvailabilityEvidence" name="rbMaternalAvailability" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaternalAvailabilityHistory" name="rbMaternalAvailability" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaternalAvailabilityRecent" name="rbMaternalAvailability" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaternalAvailabilityAcute" name="rbMaternalAvailability" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Abuse/Neglect</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAbuseNeglectEvidence" name="rbAbuseNeglect" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAbuseNeglectHistory" name="rbAbuseNeglect" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAbuseNeglectRecent" name="rbAbuseNeglect" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAbuseNeglectAcute" name="rbAbuseNeglect" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CHILD BEHAVIORAL / EMOTIONAL NEEDS</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence</td>
                        <td className='w-187'>1 = history; watch/prevent</td>
                        <td className='w-187'>2 = recent; action item </td>
                        <td className='w-187'>3 = acute; immediate action</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>Attachment</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAttachmentEvidence" name="rbAttachment" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAttachmentHistory" name="rbAttachment" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAttachmentRecent" name="rbAttachment" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAttachmentAcute" name="rbAttachment" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Regulatory<sup>1</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbRegulatoryEvidence" name="rbRegulatory" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRegulatoryHistory" name="rbRegulatory" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRegulatoryRecent" name="rbRegulatory" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRegulatoryAcute" name="rbRegulatory" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Failure to Thrive</td>
                        <td className='w-25'>
                            <input type="radio" id="rbFailureToThriveEvidence" name="rbFailureToThrive" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFailureToThriveHistory" name="rbFailureToThrive" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFailureToThriveRecent" name="rbFailureToThrive" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFailureToThriveAcute" name="rbFailureToThrive" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Depression</td>
                        <td className='w-25'>
                            <input type="radio" id="rbDepressionEvidence" name="rbDepression" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDepressionHistory" name="rbDepression" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDepressionRecent" name="rbDepression" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDepressionAcute" name="rbDepression" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Anxiety</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAnxietyEvidence" name="rbAnxiety" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAnxietyHistory" name="rbAnxiety" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAnxietyRecent" name="rbAnxiety" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAnxietyAcute" name="rbAnxiety" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Atypical Behaviors</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAtypicalBehaviorsEvidence" name="rbAtypicalBehaviors" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAtypicalBehaviorsHistory" name="rbAtypicalBehaviors" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAtypicalBehaviorsRecent" name="rbAtypicalBehaviors" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAtypicalBehaviorsAcute" name="rbAtypicalBehaviors" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            Impulsive/Hyperactivity
                            (N/A <input type="radio" id="rbImpulsiveHyperactivityNa" name="rbImpulsiveHyperactivity" className='add-only' value="na" />)
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbImpulsiveHyperactivityEvidence" name="rbImpulsiveHyperactivity" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbImpulsiveHyperactivityHistory" name="rbImpulsiveHyperactivity" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbImpulsiveHyperactivityRecent" name="rbImpulsiveHyperactivity" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbImpulsiveHyperactivityAcute" name="rbImpulsiveHyperactivity" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            Oppositional
                            (N/A <input type="radio" id="rbOppositionalNa" name="rbOppositional" className='add-only' value="na" />)
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOppositionalEvidence" name="rbOppositional" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOppositionalHistory" name="rbOppositional" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOppositionalRecent" name="rbOppositional" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOppositionalAcute" name="rbOppositional" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Adjustment to Trauma<sup>2</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustmentToTraumaEvidence" name="rbAdjustmentToTrauma" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustmentToTraumaHistory" name="rbAdjustmentToTrauma" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustmentToTraumaRecent" name="rbAdjustmentToTrauma" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdjustmentToTraumaAcute" name="rbAdjustmentToTrauma" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table >
                    <tr>
                        <td className='w-650'><span className='eleHeader'>LIFE DOMAIN FUNCTIONING</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>

                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence of needs</td>
                        <td className='w-187'>1 = history; minimal needs</td>
                        <td className='w-187'>2 = moderate needs</td>
                        <td className='w-187'>3 = severe needs</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>
                            Family
                            (N/A <input type="radio" id="rbFamilyLifeDomainNa" name="rbFamilyLifeDomain" className='add-only' value="na" />)
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyLifeDomainEvidence" name="rbFamilyLifeDomain" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyLifeDomainHistory" name="rbFamilyLifeDomain" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyLifeDomainRecent" name="rbFamilyLifeDomain" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyLifeDomainAcute" name="rbFamilyLifeDomain" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Living Situation</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLivingSituationEvidence" name="rbLivingSituation" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLivingSituationHistory" name="rbLivingSituation" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLivingSituationRecent" name="rbLivingSituation" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLivingSituationAcute" name="rbLivingSituation" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Preschool/Daycare<sup>3</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareEvidence" name="rbPreschoolDaycare" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareHistory" name="rbPreschoolDaycare" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareRecent" name="rbPreschoolDaycare" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAcute" name="rbPreschoolDaycare" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Social Functioning</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialFunctioningEvidence" name="rbSocialFunctioning" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialFunctioningHistory" name="rbSocialFunctioning" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialFunctioningRecent" name="rbSocialFunctioning" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialFunctioningAcute" name="rbSocialFunctioning" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Recreation/Play</td>
                        <td className='w-25'>
                            <input type="radio" id="rbRecreationPlayEvidence" name="rbRecreationPlay" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRecreationPlayHistory" name="rbRecreationPlay" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRecreationPlayRecent" name="rbRecreationPlay" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRecreationPlayAcute" name="rbRecreationPlay" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Developmental<sup>4</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalLifeDomainEvidence" name="rbDevelopmentalLifeDomain" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalLifeDomainHistory" name="rbDevelopmentalLifeDomain" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalLifeDomainRecent" name="rbDevelopmentalLifeDomain" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalLifeDomainAcute" name="rbDevelopmentalLifeDomain" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Motor</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotorEvidence" name="rbMotor" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotorHistory" name="rbMotor" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotorRecent" name="rbMotor" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotorAcute" name="rbMotor" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Communication</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCommunicationEvidence" name="rbCommunication" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCommunicationHistory" name="rbCommunication" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCommunicationRecent" name="rbCommunication" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCommunicationAcute" name="rbCommunication" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Medical</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalEvidence" name="rbMedical" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalHistory" name="rbMedical" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalRecent" name="rbMedical" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalAcute" name="rbMedical" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Physical</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalLifeDomainEvidence" name="rbPhysicalLifeDomain" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalLifeDomainHistory" name="rbPhysicalLifeDomain" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalLifeDomainRecent" name="rbPhysicalLifeDomain" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalLifeDomainAcute" name="rbPhysicalLifeDomain" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>
                            Sleep
                            (N/A <input type="radio" id="rbSleepNa" name="rbSleep" className='add-only' value="na" />)
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSleepEvidence" name="rbSleep" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSleepHistory" name="rbSleep" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSleepRecent" name="rbSleep" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSleepAcute" name="rbSleep" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Relation Permanence</td>
                        <td className='w-25'>
                            <input type="radio" id="rbRelationPermanenceEvidence" name="rbRelationPermanence" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRelationPermanenceHistory" name="rbRelationPermanence" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRelationPermanenceRecent" name="rbRelationPermanence" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRelationPermanenceAcute" name="rbRelationPermanence" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table >
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CAREGIVER STRENGTHS & NEEDS</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>

                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence of needs </td>
                        <td className='w-187'>1 = minimal needs</td>
                        <td className='w-187'>2 = moderate needs</td>
                        <td className='w-187'>3 = severe needs</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>Supervision</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSupervisionEvidence" name="rbSupervision" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSupervisionHistory" name="rbSupervision" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSupervisionRecent" name="rbSupervision" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSupervisionAcute" name="rbSupervision" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Involvement</td>
                        <td className='w-25'>
                            <input type="radio" id="rbInvolvementEvidence" name="rbInvolvement" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInvolvementHistory" name="rbInvolvement" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInvolvementRecent" name="rbInvolvement" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInvolvementAcute" name="rbInvolvement" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Knowledge</td>
                        <td className='w-25'>
                            <input type="radio" id="rbKnowledgeEvidence" name="rbKnowledge" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbKnowledgeHistory" name="rbKnowledge" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbKnowledgeRecent" name="rbKnowledge" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbKnowledgeAcute" name="rbKnowledge" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Empathy for Child</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmpathyforChildEvidence" name="rbEmpathyforChild" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmpathyforChildHistory" name="rbEmpathyforChild" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmpathyforChildRecent" name="rbEmpathyforChild" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmpathyforChildAcute" name="rbEmpathyforChild" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Organization</td>
                        <td className='w-25'>
                            <input type="radio" id="rbOrganizationEvidence" name="rbOrganization" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOrganizationHistory" name="rbOrganization" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOrganizationRecent" name="rbOrganization" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbOrganizationAcute" name="rbOrganization" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Social Resources</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialResourcesEvidence" name="rbSocialResources" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialResourcesHistory" name="rbSocialResources" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialResourcesRecent" name="rbSocialResources" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSocialResourcesAcute" name="rbSocialResources" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Residential Stability</td>
                        <td className='w-25'>
                            <input type="radio" id="rbResidentialStabilityEvidence" name="rbResidentialStability" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbResidentialStabilityHistory" name="rbResidentialStability" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbResidentialStabilityRecent" name="rbResidentialStability" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbResidentialStabilityAcute" name="rbResidentialStability" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Physical</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalEvidence" name="rbPhysical" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalHistory" name="rbPhysical" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalRecent" name="rbPhysical" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalAcute" name="rbPhysical" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Mental Health</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMentalHealthEvidence" name="rbMentalHealth" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMentalHealthHistory" name="rbMentalHealth" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMentalHealthRecent" name="rbMentalHealth" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMentalHealthAcute" name="rbMentalHealth" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Substance Use</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUseEvidence" name="rbSubstanceUse" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUseHistory" name="rbSubstanceUse" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUseRecent" name="rbSubstanceUse" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSubstanceUseAcute" name="rbSubstanceUse" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Developmental</td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalEvidence" name="rbDevelopmental" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalHistory" name="rbDevelopmental" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalRecent" name="rbDevelopmental" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDevelopmentalAcute" name="rbDevelopmental" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Access to Child Care</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAccessToChildCareEvidence" name="rbAccessToChildCare" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAccessToChildCareHistory" name="rbAccessToChildCare" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAccessToChildCareRecent" name="rbAccessToChildCare" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAccessToChildCareAcute" name="rbAccessToChildCare" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Military Transitions</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMilitaryTransitionsEvidence" name="rbMilitaryTransitions" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMilitaryTransitionsHistory" name="rbMilitaryTransitions" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMilitaryTransitionsRecent" name="rbMilitaryTransitions" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMilitaryTransitionsAcute" name="rbMilitaryTransitions" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Family Stress<sup>5</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyStressEvidence" name="rbFamilyStress" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyStressHistory" name="rbFamilyStress" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyStressRecent" name="rbFamilyStress" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyStressAcute" name="rbFamilyStress" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Safety</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSafetyEvidence" name="rbSafety" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSafetyHistory" name="rbSafety" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSafetyRecent" name="rbSafety" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSafetyAcute" name="rbSafety" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Marital/Partner Violence</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaritalPartnerViolenceEvidence" name="rbMaritalPartnerViolence" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaritalPartnerViolenceHistory" name="rbMaritalPartnerViolence" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaritalPartnerViolenceRecent" name="rbMaritalPartnerViolence" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMaritalPartnerViolenceAcute" name="rbMaritalPartnerViolence" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CHILD STRENGTHS</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>

                    </tr>
                    <tr>
                        <td className='w-187'>0 = centerpiece</td>
                        <td className='w-187'>1 = useful</td>
                        <td className='w-187'>2 = identified</td>
                        <td className='w-187'>3 = not yet identified</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>Family</td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyEvidence" name="rbFamily" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyHistory" name="rbFamily" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyRecent" name="rbFamily" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFamilyAcute" name="rbFamily" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Extended Family</td>
                        <td className='w-25'>
                            <input type="radio" id="rbExtendedFamilyEvidence" name="rbExtendedFamily" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbExtendedFamilyHistory" name="rbExtendedFamily" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbExtendedFamilyRecent" name="rbExtendedFamily" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbExtendedFamilyAcute" name="rbExtendedFamily" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Interpersonal</td>
                        <td className='w-25'>
                            <input type="radio" id="rbInterpersonalEvidence" name="rbInterpersonal" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInterpersonalHistory" name="rbInterpersonal" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInterpersonalRecent" name="rbInterpersonal" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbInterpersonalAcute" name="rbInterpersonal" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Adaptability</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdaptabilityEvidence" name="rbAdaptability" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdaptabilityHistory" name="rbAdaptability" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdaptabilityRecent" name="rbAdaptability" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAdaptabilityAcute" name="rbAdaptability" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Persistence</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPersistenceEvidence" name="rbPersistence" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPersistenceHistory" name="rbPersistence" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPersistenceRecent" name="rbPersistence" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPersistenceAcute" name="rbPersistence" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Curiosity</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCuriosityEvidence" name="rbCuriosity" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCuriosityHistory" name="rbCuriosity" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCuriosityRecent" name="rbCuriosity" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCuriosityAcute" name="rbCuriosity" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>CULTURE</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>0 = no evidence</td>
                        <td className='w-187'>1 = minimal needs</td>
                        <td className='w-187'>2 = moderate needs</td>
                        <td className='w-187'>3 = severe needs</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>&nbsp;</td>

                    </tr>
                    <tr>
                        <td className='w-650'>Language</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLanguageEvidence" name="rbLanguage" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLanguageHistory" name="rbLanguage" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLanguageRecent" name="rbLanguage" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLanguageAcute" name="rbLanguage" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Identity</td>
                        <td className='w-25'>
                            <input type="radio" id="rbIdentityEvidence" name="rbIdentity" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIdentityHistory" name="rbIdentity" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIdentityRecent" name="rbIdentity" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIdentityAcute" name="rbIdentity" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Ritual</td>
                        <td className='w-25'>
                            <input type="radio" id="rbRitualEvidence" name="rbRitual" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRitualHistory" name="rbRitual" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRitualRecent" name="rbRitual" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbRitualAcute" name="rbRitual" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Culture Stress</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressEvidence" name="rbCultureStress" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressHistory" name="rbCultureStress" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressRecent" name="rbCultureStress" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressAcute" name="rbCultureStress" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Cultural Differences</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCulturalDifferencesEvidence" name="rbCulturalDifferences" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCulturalDifferencesHistory" name="rbCulturalDifferences" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCulturalDifferencesRecent" name="rbCulturalDifferences" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCulturalDifferencesAcute" name="rbCulturalDifferences" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>

                <h3 className='w-750'>CANS 3-5 Modules</h3>
                <table className="sec-table">
                    <tr>
                        <td className='w-250'>
                            <sup>1</sup>go to Regulatory Module
                        </td>
                        <td className='w-250'>
                            <sup>2</sup>go to Trauma Module
                        </td>
                        <td className='w-250'>
                            <sup>3</sup>go to School Module
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <sup>4</sup>go to DD Module
                        </td>
                        <td className='w-250'>
                            <sup>5</sup>go to Family Module
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>1. REGULATORY FUNCTIONING</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Eating</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEatingEvidence" name="rbEating" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEatingHistory" name="rbEating" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEatingRecent" name="rbEating" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEatingAcute" name="rbEating" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Elimination</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEliminationEvidence" name="rbElimination" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEliminationHistory" name="rbElimination" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEliminationRecent" name="rbElimination" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEliminationAcute" name="rbElimination" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Sensory Reactivity</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSensoryReactivityEvidence" name="rbSensoryReactivity" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSensoryReactivityHistory" name="rbSensoryReactivity" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSensoryReactivityRecent" name="rbSensoryReactivity" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSensoryReactivityAcute" name="rbSensoryReactivity" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Emotional Control </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalControlEvidence" name="rbEmotionalControl" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalControlHistory" name="rbEmotionalControl" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalControlRecent" name="rbEmotionalControl" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalControlAcute" name="rbEmotionalControl" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>2. TRAUMA <i>(Characteristics of trauma experience)</i></span></td>
                        <td className='eleHeader'>&nbsp;</td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Sexual Abuse<sup>*</sup></td>
                        <td className='w-25'>
                            <input type="radio" id="rbSexualAbuseEvidence" name="rbSexualAbuse" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSexualAbuseHistory" name="rbSexualAbuse" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSexualAbuseRecent" name="rbSexualAbuse" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSexualAbuseAcute" name="rbSexualAbuse" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Physical Abuse</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalAbuseEvidence" name="rbPhysicalAbuse" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalAbuseHistory" name="rbPhysicalAbuse" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalAbuseRecent" name="rbPhysicalAbuse" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPhysicalAbuseAcute" name="rbPhysicalAbuse" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Emotional Abuse</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalAbuseEvidence" name="rbEmotionalAbuse" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalAbuseHistory" name="rbEmotionalAbuse" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalAbuseRecent" name="rbEmotionalAbuse" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalAbuseAcute" name="rbEmotionalAbuse" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Medical Trauma</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalTraumaEvidence" name="rbMedicalTrauma" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalTraumaHistory" name="rbMedicalTrauma" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalTraumaRecent" name="rbMedicalTrauma" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMedicalTraumaAcute" name="rbMedicalTrauma" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Natural Disaster</td>
                        <td className='w-25'>
                            <input type="radio" id="rbNaturalDisasterEvidence" name="rbNaturalDisaster" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNaturalDisasterHistory" name="rbNaturalDisaster" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNaturalDisasterRecent" name="rbNaturalDisaster" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNaturalDisasterAcute" name="rbNaturalDisaster" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Witness to Family Violence</td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToFamilyViolenceEvidence" name="rbWitnessToFamilyViolence" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToFamilyViolenceHistory" name="rbWitnessToFamilyViolence" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToFamilyViolenceRecent" name="rbWitnessToFamilyViolence" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToFamilyViolenceAcute" name="rbWitnessToFamilyViolence" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Witness to Community Violence</td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToCommunityViolenceEvidence" name="rbWitnessToCommunityViolence" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToCommunityViolenceHistory" name="rbWitnessToCommunityViolence" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToCommunityViolenceRecent" name="rbWitnessToCommunityViolence" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessToCommunityViolenceAcute" name="rbWitnessToCommunityViolence" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Witness/Victim - Criminal Activity</td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessVictimCriminalActivityEvidence" name="rbWitnessVictimCriminalActivity" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessVictimCriminalActivityHistory" name="rbWitnessVictimCriminalActivity" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessVictimCriminalActivityRecent" name="rbWitnessVictimCriminalActivity" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWitnessVictimCriminalActivityAcute" name="rbWitnessVictimCriminalActivity" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>War Affected</td>
                        <td className='w-25'>
                            <input type="radio" id="rbWarAffectedEvidence" name="rbWarAffected" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWarAffectedHistory" name="rbWarAffected" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWarAffectedRecent" name="rbWarAffected" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbWarAffectedAcute" name="rbWarAffected" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Terrorism Affected</td>
                        <td className='w-25'>
                            <input type="radio" id="rbTerrorismAffectedEvidence" name="rbTerrorismAffected" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTerrorismAffectedHistory" name="rbTerrorismAffected" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTerrorismAffectedRecent" name="rbTerrorismAffected" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTerrorismAffectedAcute" name="rbTerrorismAffected" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>ADJUSTMENT TO TRAUMA</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Affect Regulation </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAffectRegulationEvidence" name="rbAffectRegulation" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAffectRegulationHistory" name="rbAffectRegulation" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAffectRegulationRecent" name="rbAffectRegulation" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAffectRegulationAcute" name="rbAffectRegulation" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Re-experiencing Trauma</td>
                        <td className='w-25'>
                            <input type="radio" id="rbReExperiencingTraumaEvidence" name="rbReExperiencingTrauma" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReExperiencingTraumaHistory" name="rbReExperiencingTrauma" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReExperiencingTraumaRecent" name="rbReExperiencingTrauma" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReExperiencingTraumaAcute" name="rbReExperiencingTrauma" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Avoidance</td>
                        <td className='w-25'>
                            <input type="radio" id="rbAvoidanceEvidence" name="rbAvoidance" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAvoidanceHistory" name="rbAvoidance" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAvoidanceRecent" name="rbAvoidance" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbAvoidanceAcute" name="rbAvoidance" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Increased Arousal</td>
                        <td className='w-25'>
                            <input type="radio" id="rbIncreasedArousalEvidence" name="rbIncreasedArousal" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIncreasedArousalHistory" name="rbIncreasedArousal" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIncreasedArousalRecent" name="rbIncreasedArousal" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbIncreasedArousalAcute" name="rbIncreasedArousal" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Numbing of Responsiveness</td>
                        <td className='w-25'>
                            <input type="radio" id="rbNumbingOfResponsivenessEvidence" name="rbNumbingOfResponsiveness" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNumbingOfResponsivenessHistory" name="rbNumbingOfResponsiveness" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNumbingOfResponsivenessRecent" name="rbNumbingOfResponsiveness" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbNumbingOfResponsivenessAcute" name="rbNumbingOfResponsiveness" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Time Before Treatment</td>
                        <td className='w-25'>
                            <input type="radio" id="rbTimeBeforeTreatmentEvidence" name="rbTimeBeforeTreatment" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTimeBeforeTreatmentHistory" name="rbTimeBeforeTreatment" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTimeBeforeTreatmentRecent" name="rbTimeBeforeTreatment" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTimeBeforeTreatmentAcute" name="rbTimeBeforeTreatment" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'>Emotional Closeness to Perpetrator</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalClosenessToPerpetratorEvidence" name="rbEmotionalClosenessToPerpetrator" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalClosenessToPerpetratorHistory" name="rbEmotionalClosenessToPerpetrator" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalClosenessToPerpetratorRecent" name="rbEmotionalClosenessToPerpetrator" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmotionalClosenessToPerpetratorAcute" name="rbEmotionalClosenessToPerpetrator" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Frequency</td>
                        <td className='w-25'>
                            <input type="radio" id="rbFrequencyEvidence" name="rbFrequency" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFrequencyHistory" name="rbFrequency" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFrequencyRecent" name="rbFrequency" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFrequencyAcute" name="rbFrequency" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Duration</td>
                        <td className='w-25'>
                            <input type="radio" id="rbDurationEvidence" name="rb_Duration" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDurationHistory" name="rb_Duration" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDurationRecent" name="rb_Duration" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbDurationAcute" name="rb_Duration" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Force</td>
                        <td className='w-25'>
                            <input type="radio" id="rbForceEvidence" name="rbForce" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbForceHistory" name="rbForce" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbForceRecent" name="rbForce" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbForceAcute" name="rbForce" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Reaction to Disclosure</td>
                        <td className='w-25'>
                            <input type="radio" id="rbReactionToDisclosureEvidence" name="rbReactionToDisclosure" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReactionToDisclosureHistory" name="rbReactionToDisclosure" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReactionToDisclosureRecent" name="rbReactionToDisclosure" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbReactionToDisclosureAcute" name="rbReactionToDisclosure" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>3. SCHOOL</span></td>
                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Preschool/Daycare Quality</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareQualityEvidence" name="rbPreschoolDaycareQuality" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareQualityHistory" name="rbPreschoolDaycareQuality" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareQualityRecent" name="rbPreschoolDaycareQuality" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareQualityAcute" name="rbPreschoolDaycareQuality" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Preschool/Daycare Behavior</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareBehaviorEvidence" name="rbPreschoolDaycareBehavior" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareBehaviorHistory" name="rbPreschoolDaycareBehavior" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareBehaviorRecent" name="rbPreschoolDaycareBehavior" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareBehaviorAcute" name="rbPreschoolDaycareBehavior" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Preschool/Daycare Achievement</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAchievementEvidence" name="rbPreschoolDaycareAchievement" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAchievementHistory" name="rbPreschoolDaycareAchievement" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAchievementRecent" name="rbPreschoolDaycareAchievement" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAchievementAcute" name="rbPreschoolDaycareAchievement" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Preschool/Daycare Attendance</td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAttendanceEvidence" name="rbPreschoolDaycareAttendance" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAttendanceHistory" name="rbPreschoolDaycareAttendance" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAttendanceRecent" name="rbPreschoolDaycareAttendance" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbPreschoolDaycareAttendanceAcute" name="rbPreschoolDaycareAttendance" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>4. DEVELOPMENTAL NEEDS</span></td>
                        <td className='w-25'>< span className='eleHeader'>0</span></td>
                        <td className='w-25'>< span className='eleHeader'>1</span></td>
                        <td className='w-25'>< span className='eleHeader'>2</span></td>
                        <td className='w-25'>< span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Cognitive</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCognitiveEvidence" name="rbrbCognitive" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCognitiveHistory" name="rbrbCognitive" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCognitiveRecent" name="rbrbCognitive" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCognitiveAcute" name="rbrbCognitive" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Self Care / Daily Living</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingEvidence" name="rbSelfCareDailyLiving" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingHistory" name="rbSelfCareDailyLiving" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingRecent" name="rbSelfCareDailyLiving" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingAcute" name="rbSelfCareDailyLiving" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'><span className='eleHeader'>5. FAMILY/CAREGIVER</span></td>

                        <td className='w-25'><span className='eleHeader'>0</span></td>
                        <td className='w-25'><span className='eleHeader'>1</span></td>
                        <td className='w-25'><span className='eleHeader'>2</span></td>
                        <td className='w-25'><span className='eleHeader'>3</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Self-Care/Daily Living</td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingFamilyEvidence" name="rbSelfCareDailyLivingFamily" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingFamilyHistory" name="rbSelfCareDailyLivingFamily" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingFamilyRecent" name="rbSelfCareDailyLivingFamily" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbSelfCareDailyLivingFamilyAcute" name="rbSelfCareDailyLivingFamily" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Culture Stress</td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressFamilyEvidence" name="rbCultureStressFamily" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressFamilyHistory" name="rbCultureStressFamily" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressFamilyRecent" name="rbCultureStressFamily" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbCultureStressFamilyAcute" name="rbCultureStressFamily" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Employment/Education</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmploymentEducationEvidence" name="rbEmploymentEducation" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmploymentEducationHistory" name="rbEmploymentEducation" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmploymentEducationRecent" name="rbEmploymentEducation" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEmploymentEducationAcute" name="rbEmploymentEducation" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Educational Attainment</td>
                        <td className='w-25'>
                            <input type="radio" id="rbEducationalAttainmentEvidence" name="rbEducationalAttainment" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEducationalAttainmentHistory" name="rbEducationalAttainment" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEducationalAttainmentRecent" name="rbEducationalAttainment" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbEducationalAttainmentAcute" name="rbEducationalAttainment" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Legal</td>
                        <td className='w-25'>
                            <input type="radio" id="rbLegalEvidence" name="rbLegal" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLegalHistory" name="rbLegal" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLegalRecent" name="rbLegal" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbLegalAcute" name="rbLegal" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Motivation for Care</td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotivationforCareEvidence" name="rbMotivationforCare" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotivationforCareHistory" name="rbMotivationforCare" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotivationforCareRecent" name="rbMotivationforCare" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbMotivationforCareAcute" name="rbMotivationforCare" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Financial Resources</td>
                        <td className='w-25'>
                            <input type="radio" id="rbFinancialResourcesEvidence" name="rbFinancialResources" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFinancialResourcesHistory" name="rbFinancialResources" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFinancialResourcesRecent" name="rbFinancialResources" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbFinancialResourcesAcute" name="rbFinancialResources" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Transportation</td>
                        <td className='w-25'>
                            <input type="radio" id="rbTransportationEvidence" name="rbTransportation" className='add-only' value="0" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTransportationHistory" name="rbTransportation" className='add-only' value="1" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTransportationRecent" name="rbTransportation" className='add-only' value="2" />
                        </td>
                        <td className='w-25'>
                            <input type="radio" id="rbTransportationAcute" name="rbTransportation" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>

                <h3>Assessment Section</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Please provide specific examples to support:</span>
                    <textarea id="txt_1" name="txt_1" className="dd formTextarea"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Treatment/Interventions/Services have been tried in the past and have been helpful?</span>
                    <textarea id="txt_2" name="txt_2" className="dd formTextarea"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Treatment/Interventions/Services have been tried in the past and have not been helpful?</span>
                    <textarea id="txt_3" name="txt_3" className="dd formTextarea"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recovery Goals:</span>
                    <textarea id="txt_4" name="txt_4" className="dd formTextarea"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Intervention Strategy:</span>
                    <select id='ddlIntStrategy' name='ddlIntStrategy' className='add-only'>
                        <option value="0"></option>
                        <option value="1">Psychosocial Rehab (H2017)</option>
                        <option value="2">--Supported Housing</option>
                        <option value="3">--Supported Employment</option>
                        <option value="4">--Illness Management and Recovery</option>
                        <option value="5">--Engagement Activity</option>
                        <option value="6">Skills Training (H2014)</option>
                        <option value="7">--Aggression Replacement Techniques</option>
                        <option value="8">--Skillstreaming</option>
                        <option value="9">--Nurturing Parent</option>
                        <option value="10">----Parents and Their Infants - Toddlers & Preschoolers</option>
                        <option value="11">----Parents & Their School Age Children </option>
                        <option value="12">----Spanish Speaking Parents</option>
                        <option value="13">----Parents & Adolescents </option>
                        <option value="14">----Its all about being a Teen</option>
                        <option value="15">--Seeking Safety</option>
                        <option value="16">--PAYA</option>
                        <option value="17">----Money, Home and Food Management</option>
                        <option value="18">----Personal Care, Health, Social Skills and Safety</option>
                        <option value="19">----Education, Jobs Seeking Skills and Job Maintenance </option>
                        <option value="20">----Housing, Transportation, Community Resources</option>
                        <option value="21">----Young Parents Guide</option>
                        <option value="22">----Household Management Activities</option>
                        <option value="23">-- Medication Training and Support (H0034)</option>
                        <option value="24">Counseling</option>
                        <option value="25">--Parent-Child Psychotherapy</option>
                        <option value="26">--Family Counseling</option>
                        <option value="27">--Trauma-Focused CBT</option>
                        <option value="28">--CBT</option>
                        <option value="29">----Coping Cat</option>
                        <option value="30">----The Cat Project</option>
                        <option value="31">----Taking Action</option>
                        <option value="32">----Adolescent Coping with Depression</option>
                        <option value="33">--Family Counseling</option>
                        <option value="34">Crisis Intervention (H2011)</option>
                    </select>
                </p>
            </div>
        </form >

    )
}











